import React from "react";
import { Link } from "react-router-dom";
import error_img from '../assets/error_img.png'
import {useAuth} from "../contexts/AuthContext";

export const ErrorPage: React.FC = () => {

    const  { logOut } = useAuth();
    logOut();

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 text-gray-800">

            <div className="mt-10">
                <img
                    src={error_img}
                    alt="Error Illustration"
                    className="w-80 h-auto"
                />
            </div>
            <div className="text-center ">
                <p className="mt-4 text-xl font-semibold">
                    Something went wrong
                </p>
                <p className="mt-2 text-gray-600">
                    We encountered an unexpected error. Please try again later or contact support if the issue persists.
                </p>
                <Link
                    to="/"
                    className="mt-6 inline-block bg-green-600 text-white px-6 py-2 rounded shadow hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-offset-2"
                >
                    Go to Login
                </Link>
            </div>

        </div>
    );
};
